import Vue from 'vue';
import Router from 'vue-router';
import Admin from './layouts/Admin.vue';
import { adminGuard, loginGuard, toursGuard } from './middleware/guards';
import Cinema from './views/Cinema.vue';
import Comments from './views/Comments.vue';
import Dashboard from './views/Dashboard.vue';
import Documents from './views/Documents.vue';
import Login from './views/Login.vue';
import MeetAndGreetTicketPaymentView from './views/MeetAndGreetTicketPayment.vue';
import News from './views/News.vue';
import Questions from './views/Questions.vue';
import RadioView from './views/Radio.vue';
import SearchView from './views/Search.vue';
import SearchStatisticsView from './views/SearchStatistics.vue';
import Store from './views/Store.vue';
import Studio from './views/Studio.vue';
import TourView from './views/Tour.vue';
import TourBundle from './views/TourBundle.vue';
import TourGatherings from './views/TourGatherings.vue';
import TourNoShows from './views/TourNoShows.vue';
import TourPhotos from './views/TourPhotos.vue';
import TourSettings from './views/TourSettings.vue';
import TourShows from './views/TourShows.vue';
import TourStatistics from './views/TourStatistics.vue';
import User from './views/User.vue';
import UserComments from './views/UserComments.vue';
import UserEmails from './views/UserEmails.vue';
import UserInfo from './views/UserInfo.vue';
import UserRemarks from './views/UserRemarks.vue';
import UserSettings from './views/UserSettings.vue';
import UserShows from './views/UserShows.vue';
import UserTransactions from './views/UserTransactions.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: loginGuard,
    },
    {
      path: '/',
      name: 'admin',
      component: Admin,
      beforeEnter: adminGuard,
      redirect: '/dashboard',
      children: [
        { path: '/dashboard', name: 'dashboard', component: Dashboard },
        { path: '/news', name: 'news', component: News },
        { path: '/questions', name: 'questions', component: Questions },
        { path: '/cinema', name: 'cinema', component: Cinema },
        { path: '/studio', name: 'studio', component: Studio },
        { path: '/radio', name: 'radio', component: RadioView },
        { path: '/store', name: 'store', component: Store },
        { path: '/tours', name: 'tours', beforeEnter: toursGuard },
        {
          path: '/tours/:tourId',
          name: 'tour',
          component: TourView,
          props: true,
          children: [
            { path: 'shows', name: 'shows', component: TourShows, props: true },
            { path: 'settings', name: 'settings', component: TourSettings, props: true },
            { path: 'gatherings', name: 'gatherings', component: TourGatherings, props: true },
            { path: 'bundle', name: 'bundle', component: TourBundle, props: true },
            { path: 'photos', name: 'photos', component: TourPhotos, props: true },
            { path: 'statistics', name: 'statistics', component: TourStatistics, props: true },
            { path: 'no-shows', name: 'no-shows', component: TourNoShows, props: true },
          ],
          redirect: '/tours/:tourId/shows',
        },
        { path: '/docs', name: 'Documents', component: Documents },
        { path: '/comments', name: 'comments', component: Comments },
        {
          path: '/search',
          component: SearchView,
          children: [
            { path: '', name: 'users', component: SearchStatisticsView },
            {
              path: 'user/:id',
              name: 'user',
              component: User,
              props: true,
              children: [
                { path: '', name: 'user-info', component: UserInfo, props: true },
                { path: 'transactions', name: 'user-transactions', component: UserTransactions, props: true },
                { path: 'shows', name: 'user-shows', component: UserShows, props: true },
                { path: 'remarks', name: 'user-remarks', component: UserRemarks, props: true },
                { path: 'emails', name: 'user-emails', component: UserEmails, props: true },
                { path: 'comments', name: 'user-comments', component: UserComments, props: true },
                { path: 'settings', name: 'user-settings', component: UserSettings, props: true },
              ],
              redirect: '/search/user/:id',
            },
            {
              path: 'payment/:id',
              name: 'meet-and-greet-ticket-payment',
              component: MeetAndGreetTicketPaymentView,
              props: true,
            },
          ],
        },
      ],
    },
  ],
});
